// SuccessPage.tsx
/* eslint-disable no-console */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { refreshToken, getAuthInstance } from "../../../utils/firebase"; // Importa l'istanza auth
import nexumLogo from "../../assets/nexumLogo.png";
import Navbar from "../../shared/components/navbar";
import Sidebar from "../../shared/components/sidebar";
import Button from "../../shared/components/button/button";
import MainLayout from "../../shared/components/MainLayout";
import { motion, MotionConfig } from "framer-motion";
import { CheckCircle2, Package2 } from "lucide-react";
import Button2 from "../../shared/components/button/Button2";
import Loader from "../../shared/components/loader/Loader";
const SuccessPage: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const updateToken = async () => {
      const auth = getAuthInstance(); // Ottieni l'istanza di autenticazione
      try {
        // Ottieni l'utente attuale
        const user = auth.currentUser;

        if (user) {
          // Recupera il token aggiornato
          const token = await user.getIdToken(true); // 'true' forzare un refresh
          // Memorizza il token in sessionStorage
          localStorage.setItem("token", token); // Usa sessionStorage per la sessione corrente
        }
      } catch (error) {
        console.error("Errore nel recupero del token:", error);
      } finally {
        setLoading(false); // Disattiva il loading una volta finito
      }
    };

    const timeoutId = setTimeout(() => {
      updateToken();
    }, 8000);
  }, []); // Esegui solo una volta al caricamento del componente

  const handleButtonClick = () => {
    navigate("/private/productlistV3/");
  };

  return (
    <MainLayout>
      {loading && <Loader isLoading={loading} />}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8"
      >
        <div className="max-w-4xl mx-auto">
          <motion.div
            className="bg-white rounded-2xl shadow-xl overflow-hidden"
            whileHover={{ scale: 1.01 }}
            transition={{ duration: 0.2 }}
          >
            <div className="grid md:grid-cols-2 grid-cols-1 min-h-[450px]">
              {/* Left Side - Logo */}
              <div className="p-8 bg-gradient-to-br from-sky-200 to-white flex items-center justify-center ">
                <img
                  className="max-w-[200px] w-full"
                  src={nexumLogo}
                  alt="nexumLogo"
                />
              </div>
              <div className="login-right">
                <div className="login-right-wrap p-4 text-center pt-8">
                  <div className="flex flex-col items-center justify-center mt-4 mb-6">
                    <CheckCircle2 className="w-24 h-24 text-green-500" />
                  </div>
                  <h1 className="text-2xl font-bold text-gray-900 ">
                    The payment has been successful
                  </h1>
                  <p className="text-gray-400 mt-4">
                    Please check your email for the invoice
                  </p>
                  <p className="text-gray-400 mt-4">
                    If you have any questions, please contact us at{" "}
                    <a href="mailto:info@nexum.it" className="text-sky-500">
                      info@nexum.it
                    </a>
                  </p>
                  <Button2
                    title="Go to Product"
                    onClick={handleButtonClick}
                    icon={Package2}
                    className="w-full mt-6 py-3 bg-green-500"
                    iconPosition="left"
                  />
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </MainLayout>
  );
};

export default SuccessPage;
